import React from 'react';
import { STATS } from '../mock';

const Stats = () => {
  return (
    <section className="relative py-16 lg:py-24 bg-slate-50 border-y border-slate-200/70">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-10">
          <p className="text-[11.5px] font-medium tracking-[0.2em] text-slate-400 uppercase">
            Founder-led delivery experience
          </p>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-10">
          {STATS.map((s, i) => (
            <div
              key={s.label}
              className={`text-center lg:text-left ${
                i !== 0 ? 'lg:pl-10 lg:border-l lg:border-slate-200' : ''
              }`}
            >
              <div className="font-display text-[40px] lg:text-[56px] font-semibold text-slate-900 tracking-tight leading-none">
                {s.value}
              </div>
              <div className="mt-2 text-[13.5px] text-slate-500 uppercase tracking-[0.14em]">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
